import React, { FunctionComponent } from 'react';
import { useMeasure } from 'react-use';

import {
  $AddAndRemoveContainer,
  $AddAndRemoveSizer,
} from './AddAndRemove.styles';

const AddAndRemove: FunctionComponent<React.PropsWithChildren> = ({
  children,
}) => {
  const [ref, { height }] = useMeasure<HTMLDivElement>();

  return (
    <$AddAndRemoveContainer $height={height}>
      <$AddAndRemoveSizer ref={ref}>{children}</$AddAndRemoveSizer>
    </$AddAndRemoveContainer>
  );
};

export default AddAndRemove;
